/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Get_StartedInputs */

const en_dashboard_get_started = /** @type {(inputs: Dashboard_Get_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your next steps`)
};

const de_dashboard_get_started = /** @type {(inputs: Dashboard_Get_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loslegen`)
};

const fr_dashboard_get_started = /** @type {(inputs: Dashboard_Get_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commencer`)
};

const es_dashboard_get_started = /** @type {(inputs: Dashboard_Get_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comenzar`)
};

const it_dashboard_get_started = /** @type {(inputs: Dashboard_Get_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizia`)
};

const nl_dashboard_get_started = /** @type {(inputs: Dashboard_Get_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aan de slag`)
};

const pl_dashboard_get_started = /** @type {(inputs: Dashboard_Get_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozpocznij`)
};

const fi_dashboard_get_started = /** @type {(inputs: Dashboard_Get_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aloita`)
};

const da_dashboard_get_started = /** @type {(inputs: Dashboard_Get_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kom i gang`)
};

const sv_dashboard_get_started = /** @type {(inputs: Dashboard_Get_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Börja`)
};

/**
* | output |
* | --- |
* | "Your next steps" |
*
* @param {Dashboard_Get_StartedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const dashboard_get_started = /** @type {((inputs?: Dashboard_Get_StartedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Get_StartedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_dashboard_get_started(inputs)
	if (locale === "fr") return fr_dashboard_get_started(inputs)
	if (locale === "es") return es_dashboard_get_started(inputs)
	if (locale === "it") return it_dashboard_get_started(inputs)
	if (locale === "nl") return nl_dashboard_get_started(inputs)
	if (locale === "pl") return pl_dashboard_get_started(inputs)
	if (locale === "fi") return fi_dashboard_get_started(inputs)
	if (locale === "da") return da_dashboard_get_started(inputs)
	if (locale === "sv") return sv_dashboard_get_started(inputs)
	return en_dashboard_get_started(inputs)
});